import React, { useState, useEffect } from "react";
import useReactApexChart from "../../hook/useReactApexChart";
import ReactApexChart from "react-apexcharts";

const SupportTracker = ({ dataSet }) => {


  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [opt, setOpts] = useState({
    colors: ["#FF9F29", "#487FFF", "#45B369", "#458987"],
    labels: [],
    legend: {
      show: false,
    },
    chart: {
      type: "donut",
      height: 270,
      sparkline: {
        enabled: true, // Remove whitespace
      },
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    stroke: {
      width: 0,
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });






  useEffect(() => {
    if (!dataSet) return;

    // Construimos nuevos arrays u objetos
    const newData = [];
    const newLabels = [];
    let aux = 0;
    Object.entries(dataSet).forEach(([key, value]) => {
      newLabels.push(key);
      newData.push(value);
      aux += value;
    });

    // Actualizamos el estado una sola vez
    setTotal(aux);
    setData(newData);
    setLabels(newLabels);
    //setOpts( {...opt, labels : labels } );

  }, [dataSet]);


  useEffect(() => {
    setOpts((prev) => ({
      ...prev,
      labels: labels,
    }));
  }, [labels]);

  return (
    <div className='col-xxl-12 col-xl-12'>
      <div className='card h-100'>
        <div className='card-body p-24'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between'>
            <h6 className='mb-2 fw-bold text-lg'>Estatus</h6>
          </div>
          <div className='mt-32 d-flex  gap-24 align-items-center justify-content-between'>
            <div className='d-flex flex-column gap-24'>

              {dataSet && Object.entries(dataSet).map(([key, value]) => (
                <div key={key} className='d-flex align-items-center gap-3'>
                  <div className='w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-primary-100 flex-shrink-0'>
                    <img
                      src='assets/images/home-nine/ticket1.png'
                      alt=''
                      className=''
                    />
                  </div>
                  <div className='flex-grow-1'>
                    <h6 className='text-md mb-0 fw-bold'>{value}</h6>
                    <span className='text-sm text-secondary-light fw-normal'>
                      {key} {" "}
                    </span>
                  </div>
                </div>
              ))}

            </div>
            <div className='position-relative'>
              <div
                id='userOverviewDonutChart'
                className='apexcharts-tooltip-z-none'
              >
                <ReactApexChart
                  options={opt}
                  series={data}
                  type='donut'
                  height={270}
                />
              </div>
              <div className='text-center max-w-135-px max-h-135-px bg-warning-focus rounded-circle p-16 aspect-ratio-1 d-flex flex-column justify-content-center align-items-center position-absolute start-50 top-50 translate-middle'>
                <h6 className='fw-bold'>{total}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportTracker;
